import React from 'react';

const DEMO_ITEMS = [
    { name: 'GT2_EMS2', value: 0 },
    { name: 'GT1_EMS1', value: 0 },
    { name: 'GT4_EMS4', value: 0 },
    { name: 'GT3_EMS3', value: 0 },
];

const LeaderboardWidget = ({ config }) => {
    const { dataSource = {}, settings = {} } = config;
    const items = (dataSource.items || DEMO_ITEMS).slice().sort((a, b) => b.value - a.value);
    const max = Math.max(...items.map((i) => i.value), 1);
    const unit = settings.unit || 'kWh';

    return (
        <div className="leaderboard-widget">
            {items.map((item, i) => (
                <div className="leaderboard-widget__row" key={item.name}>
                    <span className="leaderboard-widget__rank">{i + 1}</span>
                    <div className="leaderboard-widget__main">
                        <div className="leaderboard-widget__label">
                            <span>{item.name}</span>
                            <span>{item.value} {unit}</span>
                        </div>
                        <div className="leaderboard-widget__track">
                            <div className="leaderboard-widget__fill" style={{ width: `${(item.value / max) * 100}%` }} />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LeaderboardWidget;
